export default {
  namespace: 'user', // 注意定义namespace, 将会在store中存储
  state: {
    openId: '123',
    id: ''
  },
  getters: {
    openId: state => state.openId,
    id: state => state.id
  },
  actions: {
    updateUserInfo ({commit, state}, payload) {
      commit('updateUserInfo', payload)
    }
  },
  mutations: {
    updateUserInfo (state, payload) {
      for (let prop in payload) {
        state[prop] = payload[prop]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js